import { get } from 'lodash';
const antdErrorDisplayAdaptor = (meta) => {
  const errors = get(meta, 'errors') || [];
  return {
    error: errors.length > 0,
    help: errors.join(' '),
  };
};

const itemWrapperErrorDisplayAdaptor = (meta) => {
  const errors = get(meta, 'errors') || [];
  return {
    error: errors.length > 0,
    errorText: errors.join(' '),
  };
};

export { itemWrapperErrorDisplayAdaptor, antdErrorDisplayAdaptor };
